import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get, pickBy, identity}from 'lodash';
import classNames from 'classnames';

import Icon from '../Icon';

type TextInputProps = {
	name: string;
	required?: boolean;
	pattern?: RegExp;
	maxLength?: number;
	onFocus?: () => void;
	onBlur?: () => void;
	readOnly?: boolean;
	deletable?: boolean;
	hasPlaceholderForIcon?: boolean;
	validate?: (value: string) => boolean;
	className?: string;
}
export default (props: TextInputProps) => {
	const {
		name,
		required,
		pattern,
		maxLength,
		onFocus = () => {},
		onBlur = () => {},
		readOnly = false,
		deletable = true,
		hasPlaceholderForIcon = false,
		validate,
		className,
	} = props;
	const {register, errors, setValue, getValues, triggerValidation} = useFormContext();
	const isInvalid = Boolean(get(errors, name));
	const hasValue = Boolean(get(getValues({nest: true}), name));
	const hasIcon = deletable && hasValue;
	const isToBeValidated = required || pattern || validate;

	return (
		<>
			<input
				className={classNames(
					styles.input,
					isInvalid && styles.isInvalid,
					readOnly && styles.readonly,
					hasIcon || hasPlaceholderForIcon && styles.hasIcon,
					!hasValue && required && styles.isRequired,
					className,
				)}
				id={name}
				maxLength={maxLength}
				{...{name, onFocus, onBlur, readOnly}}
				ref={register(pickBy({required: required && !validate, pattern, validate}, identity))}
			/>
			{
				hasIcon &&
					<Icon
						name="times"
						onClick={() => setValue(name, '', true)}
						className={styles.icon}
					/>
			}
		</>
	);
}
